import { Clipboard } from 'lucide-react';

export default function UrlForm({ value, onChange, onPaste }) {
  return (
    <div className="card">
      <textarea
        className="input-field min-h-[100px] resize-none"
        placeholder="https://votre-lien-ici.com/..."
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      <button
        type="button"
        onClick={onPaste}
        className="mt-3 min-h-11 flex items-center gap-2 text-accent-blue text-sm font-medium active:scale-95 transition-transform"
      >
        <Clipboard className="w-5 h-5" />
        Coller depuis le presse-papier
      </button>
    </div>
  );
}
